// extracted by mini-css-extract-plugin
export default {"navbarMobile":"navbarmobile-module--navbar-mobile--42w0T","navigation":"navbarmobile-module--navigation--ZlvnF"};